import { ApplicationConfig, provideZoneChangeDetection } from '@angular/core'
import { provideRouter } from '@angular/router'
import { AuthConfig, HttpsValidationType, provideElderAuthDynamic } from '@elderbyte/ngx-auth'
import {
  provideElderBrandAssets,
  provideElderDefaults,
  provideElderHttpClient,
  provideElderLanguage,
  provideElderThemeInit,
  provideElderTranslate,
} from '@elderbyte/ngx-starter'
import { environment } from '../environments/environment'
import { appRoutes } from './app-routes'
import { LoggerFactory } from '@elderbyte/ts-logger'

export const appConfig: ApplicationConfig = {
  providers: [
    provideZoneChangeDetection(),
    provideRouter(appRoutes),
    provideElderHttpClient(),
    provideElderDefaults(),
    provideElderLanguage({ langs: ['de', 'en'], defaultLang: 'de' }),
    provideElderTranslate(),
    provideElderBrandAssets(),
    provideElderAuthDynamic({
      provide: AuthConfig,
      useFactory: createAuthConfig,
    }),
    provideElderThemeInit(),
  ],
}

export function createAuthConfig(): AuthConfig {
  LoggerFactory.getLogger('createAuthConfig').info('createAuthConfig with env:', environment)

  return {
    issuerUrl: environment.issuerUrl,
    validation: { httpsRequired: HttpsValidationType.None },
    clientId: environment.clientId,
    roleHierarchy: environment.roleHierarchy,
    scope: environment.scope,
    accessDeniedRoute: 'app/accessdenied',
    mock: { enable: !environment.issuerUrl },
  }
}
